import { merge, startCase } from 'lodash';

import { ChartConfig } from '@/components/ui/chart/base';
import { colors } from '@/theme/constants';
import { ChartType, ChartTypeToProps } from '@/types/charts';

import { CHART_CONFIG } from './constants';

export const getChartSettings = ({
  type,
  overrides = {},
}: {
  type: ChartType;
  overrides?: Record<string, any>;
}): ChartTypeToProps[ChartType]['settings'] => {
  const baseConfig = CHART_CONFIG[type];
  const finalConfig = merge({}, baseConfig, overrides) as ChartTypeToProps[ChartType]['settings'];
  return finalConfig;
};

/**
 * Generate a chart config object for a given set of keys.
 *
 * @param keys
 * @param options
 */

export const generateChartConfig = ({
  keys,
  options,
  colorOverrides = colors.charts.line,
}: {
  keys: string[];
  options?: Record<string, any>;
  colorOverrides?: string[];
}): ChartConfig => {
  return keys.reduce((config, key, index) => {
    return {
      ...config,
      [key]: {
        color: colorOverrides[index % colorOverrides.length], // Cycle through available colors
        label: startCase(options?.[key]?.label || key),
      },
    };
  }, {});
};

/**
 * Calculate the start and end angles for a radial chart.
 */
export const calculateRadialAnglesForPercentage = ({
  value,
  total,
  maxAngle = 360,
}: {
  value: number;
  total: number;
  maxAngle?: number;
}) => {
  const percentage = (value / total) * 100;
  const angle = (percentage / 100) * maxAngle;

  return {
    startAngle: 0,
    endAngle: angle,
    percentage,
  };
};
